import axios from 'axios';

/**
 * @description Get API to fetch global coupon list
 * @async
 * @function GetGlobalCouponListApi
 * @returns Promise
**/

const GetGlobalCouponListApi = async (pageNumber = 1, pageSize = 10) => {
    try {
        let apiUrl = `https://adminapi.thunderadmin.com/api/v1/coupon/global-coupon-codes?pageNumber=${pageNumber}&pageSize=${pageSize}`;
         const config = {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('access-token')
        } 
    }
        const response = await axios.get(apiUrl, config)
        return response.data
    } catch (e) {
        return e
    }
}

export default GetGlobalCouponListApi;
